export default __webpack_public_path__ + "static/media/BELT-BNB-BELT.29ffd46a.png";